import { useState, useEffect } from 'react';
import { debounce } from 'throttle-debounce';

/**
 * Hook that triggers when the user has not moved the mouse for a given duration.
 * @param {number} threshold - Value in milliseconds for the timeout to trigger.
 */
export function useInactivityDuration(timeoutDuration = 10000): boolean {
    const [isIdle, setIsIdle] = useState<boolean>(false);
    const [lastMoveTimestamp, setLastMoveTimestamp] = useState<number>(Date.now());

    useEffect(() => {
        const handleMouseMove = debounce(200, () => {
            setLastMoveTimestamp(Date.now());
            setIsIdle(false);
        });

        window.addEventListener('mousemove', handleMouseMove);

        const interval = setInterval(() => {
            if (Date.now() - lastMoveTimestamp > timeoutDuration) {
                setIsIdle(true);
            }
        }, 1000);

        return () => {
            handleMouseMove.cancel();

            window.removeEventListener('mousemove', handleMouseMove);
            clearInterval(interval);
        };
    }, [lastMoveTimestamp, timeoutDuration]);

    return isIdle;
}
